import { api } from "@/api"

import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

import type { ImportResponse } from "./import"
import { parseImportResponse } from "./import"

export type ImportProduct = {
  id: string | null
  parentCategory: string | null
  name: string
  description: string
  hasVariablePrice: boolean
  price: number
  vatRate: number | null
  selfColor: string | null
}

type RetrieveImportJobResponse =
  RecursivelyConvertDatesToStrings<
    ImportResponse<ImportProduct>
  >

export const retrieveImport = async (importId: string) => {
  const { body } = await api.get<RetrieveImportJobResponse>(
    `/imports/${importId}/`
  )
  return parseImportResponse<ImportProduct>(body)
}

type RetrieveLatestImportJobResponse = {
  latestJob: RetrieveImportJobResponse | null
}

export const retrieveLatestImport = async () => {
  const { body } =
    await api.get<RetrieveLatestImportJobResponse>(
      `/imports/latest/`
    )

  return body.latestJob
    ? parseImportResponse<ImportProduct>(body.latestJob)
    : null
}

export const useImport = (importId: MaybeRef<string>) =>
  useQuery({
    queryKey: [BASE_PRODUCT_IMPORT_QUERY_KEY, importId],
    queryFn: async () => {
      const importResponse = await retrieveImport(
        unref(importId)
      )
      return importResponse
    },
    refetchInterval: 5 * 1000,
  })

export const useLatestImport = () =>
  useQuery({
    queryKey: [BASE_PRODUCT_IMPORT_QUERY_KEY, "latest"],
    queryFn: async () => {
      const importResponse = await retrieveLatestImport()
      return importResponse
    },
    refetchInterval: 5 * 1000,
  })
